import type { ParamMatcher } from '@sveltejs/kit';

const LANGUAGE_CODE_REGEXP = /^([a-z]{2}-[a-z]{2})$|^$/;

export const match: ParamMatcher = (param: string) => {
  return LANGUAGE_CODE_REGEXP.test(param);
};
